import { formSubmitClear, formComplete } from 'actions/forms'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const FEATURETOGGLE_GET = 'FEATURETOGGLE_GET'
export const FEATURETOGGLE_RECEIVED = 'FEATURETOGGLE_RECEIVED'
export const FEATURETOGGLE_GET_ERROR = 'FEATURETOGGLE_GET_ERROR'
export const FEATURETOGGLE_SAVE_REQUEST = 'FEATURETOGGLE_SAVE_REQUEST'
export const FEATURETOGGLE_SAVE_ERROR = 'FEATURETOGGLE_SAVE_ERROR'
export const FEATURETOGGLE_SAVE_COMPLETE = 'FEATURETOGGLE_SAVE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const featureToggleReceive = featureToggle => ({
  type: FEATURETOGGLE_RECEIVED,
  featureToggle,
})

const saveFeatureToggleRequest = () => ({
  type: FEATURETOGGLE_SAVE_REQUEST,
})

const saveFeatureToggleError = errors => ({
  error: errors[0].error,
  type: FEATURETOGGLE_SAVE_ERROR,
})

const saveFeatureToggleComplete = featureToggle => ({
  type: FEATURETOGGLE_SAVE_COMPLETE,
  featureToggle,
})

export function getFeatureToggles(employeeId) {
  return (dispatch) => {
    dispatch(fetching(FEATURETOGGLE_GET))
    agent.FeatureToggle.list(employeeId)
      .then((result) => {
        dispatch(featureToggleReceive(result))
      })
      .catch((rawError) => {
        // console.error('getPartnerPlanOverviewPages error', rawError, rawError.stack, window.location)
        console.error('Getting feature toggle error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching feature toggle', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export const editFeatureToggle = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveFeatureToggleRequest())
  agent.FeatureToggle.update(payload).then((response) => {
    dispatch(saveFeatureToggleComplete(response))
    dispatch(notify((payload.is_enabled ?
      `${payload.feature_name} enabled.` :
      `${payload.feature_name} disabled.`), 'success'))

    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving feature toggle, please try again later', 'warning'))
      console.warn('Err <editFeatureToggle>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}




// WEBPACK FOOTER //
// ./src/actions/featureToggle.js